var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vehicle-rating"},[_c('svg-icon',{attrs:{"name":_vm.numOfReviews > 0 ? 'star' : 'star_border'}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rating))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }